import { TableCard } from 'app/components'
import { GruposListHeader } from './components/header/GruposListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { GruposTable } from './table/GruposTable'

const GruposList = () => {
  return (
    <TableCard>
      <GruposListHeader />
      <GruposTable />
    </TableCard>
  )
}

export const GruposListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <GruposList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
